import { c as _c } from "react/compiler-runtime";
import { VStack, Box, Text, HStack, Separator, Heading, Stack } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
type MeetTheHostsProps = {};
export const MeetTheHosts = props => {
  const $ = _c(6);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HStack gap={8} width="full"><Separator flex={1} /><Text color="colorPalette.fg/50" textStyle="label">Hosted by</Text><Separator flex={1} /></HStack>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== getBreakpointValue) {
    t1 = getBreakpointValue(["column", "column", "row", "row", "row"]);
    $[1] = getBreakpointValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = pageSections.map(_temp);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <VStack align="center" gap={12} width="full">{t0}<Stack direction={t1} gap={8}>{t2}</Stack></VStack>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
type HostCardProps = {
  hostName?: string;
  title?: string;
  bio?: string;
  image?: string;
};
const HostCard = props => {
  const $ = _c(20);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue(["column", "column", "column", "column", "column"]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = `url('${props.image}')`;
  let t2;
  if ($[2] !== t1) {
    t2 = <Box bgImage={t1} bgPos="center 25%" bgSize="cover" borderRadius="2xl" boxShadow="sm" paddingBottom="70%" width="full" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.hostName) {
    t3 = <Heading size="xl">{props.hostName}</Heading>;
    $[4] = props.hostName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props.title) {
    t4 = <Text color="colorPalette.fg" fontSize="md" fontWeight={600}>{props.title}</Text>;
    $[6] = props.title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <VStack align="flex-start" gap={1}>{t3}{t4}</VStack>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== props.bio) {
    t6 = <Text color="colorPalette.fg/75" fontFamily="longform" fontSize="md">{props.bio}</Text>;
    $[11] = props.bio;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <VStack align="flex-start" gap={4} paddingRight={12} width="full">{t5}{t6}</VStack>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t0 || $[17] !== t2 || $[18] !== t7) {
    t8 = <Stack align="center" direction={t0} gap={8} width="full">{t2}{t7}</Stack>;
    $[16] = t0;
    $[17] = t2;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
const pageSections = [{
  hostName: 'Wil Schroter',
  title: 'Founder + CEO, Startups.com',
  bio: `Wil is a serial Founder having launched 9 companies over 25+ years, 3 being venture funded
    and 4 having been sold. He generally argues that Founders need to take a much different
    view of how to build startups.`,
  image: '/assets/illustration/podcasts/wil-schroter-full.jpg'
}, {
  hostName: 'Ryan Rutan',
  bio: `Ryan is a serial founder with 5 companies spanning 3 continents, 20 years and 2 exits.
    He generally argues with Wil.`,
  title: 'Founding Partner + CMO, Startups.com',
  image: '/assets/illustration/podcasts/ryan-rutan-full.jpg'
}];
function _temp(section, index) {
  return <HostCard key={index} bio={section.bio} hostName={section.hostName} image={section.image} title={section.title} />;
}